import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Typography from '../../base/Typography';
import CheckmarkBoldIcon from '../../icons/utility/CheckmarkBold';

export const ULStyled = styled.ul`
  ${({ disableBottomPadding }) => css`
    padding: 0 0 0 ${rem(40)};
    ${disableBottomPadding
      && css`
        margin-bottom: 0;
      `}
  `}
`;

export const LIStyled = styled.li`
  list-style: none;
  position: relative;
`;

export const IconStyled = styled(CheckmarkBoldIcon)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const largeUp = theme.largeUp();
    let top = 2;
    if (largeUp) {
      top = 5;
    } else if (mediumUp) {
      top = 5;
    }

    return css`
      position: absolute;
      padding-right: 0.5rem;
      /* These top/left values will need to be adjusted once we throw the correct checkmark icon in. */
      top: ${rem(top)};
      left: ${rem(-40)};
    `;
  }}
`;

export const TypographyListItemHeader = styled(Typography)`
  padding-bottom: ${rem(10)};
`;
